// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_user-verified-form_KaYyX1{display:flex;flex-direction:column;justify-content:center}", "",{"version":3,"sources":["webpack://./src/domains/Users/components/UserSecurity/PhoneVerifiedModal/styles.scss"],"names":[],"mappings":"AAAA,kCACE,YAAA,CACA,qBAAA,CACA,sBAAA","sourcesContent":[".user-verified-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-verified-form": "styles_user-verified-form_KaYyX1",
	"userVerifiedForm": "styles_user-verified-form_KaYyX1"
};
export default ___CSS_LOADER_EXPORT___;
